var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{style:({height: _vm.height}),attrs:{"span":24}},[_c('div',{class:_vm.className,style:({height:_vm.chartHeight,width:_vm.chartWidth}),on:{"click":_vm.onClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1acb1dd6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3d/Line3dChart.vue
// module id = 888
// module chunks = 0